// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../../_common/api/QuestRoutes';
import { Regex } from '../../../_common/api/regex';
import { currency, generateId } from '../../../_common/api/utility';
import Cart from '../../../_common/Cart';
import Button from '../../../_common/form/Button';
import Form from '../../../_common/form/Form';
import Input from '../../../_common/form/Input';
import Title from '../../../_common/form/Title';
import { useGlobalState } from '../../../_common/globalState/GlobalStateProvider';
import Modal from '../../../_common/Modal';
import LogIn from '../../LogIn';
import Loading from '../../../_common/Loading';
import { HamQuest } from '../../../../App';

const Row = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 1em;
`;
const Col = styled.div`
    display: flex;
    flex-direction: column;
`;
const CardValues = styled.div`
    display: flex;
    justify-content: center;
`;
const Forms = styled(Form)`
    display: flex;
    align-items: center;
`;

const Cards = () => {
    const {
        state: {
            active_user,
            site_config
        },
    } = useGlobalState();

    const [cards, setCards] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.giftCards)
            .then((res) => setCards(res))
    }, [])

    return (
        <div>
            <Forms
                inputs={{
                    cardNumber: '',
                }}
                onSubmit={(e) =>
                    HamQuest.getQuery(QuestRoute.giftCard.balance, {
                        cardNumber: e.cardNumber
                    })
                        .then(res => Modal.Show({
                            title: site_config.cardName + ' Balance',
                            body:
                                <Col>
                                    {res.responseMessage && <div>Status: {res.responseMessage}</div>}
                                    <div>Balance: {currency.format(res.balance ?? 0)}</div>
                                </Col>
                        }))
                }
                submitButton='Check'
                row
            >
                <Input
                    label='Check Gift Card Balance'
                    name='cardNumber'
                    mask={Regex.mask.creditCard}
                    sanitize={Regex.match.notNumbers}
                    maxLength={19}
                    validate={Regex.test.creditCard}
                    required
                />
            </Forms>
            {   cards ?
                    <div>
                        {
                            cards.filter(e => e.appProductType === 'GiftCard').length ?
                                <>
                                    <Title>New Gift Cards</Title>
                                    {
                                        cards
                                            .filter(e => e.appProductType === 'GiftCard')
                                            .sort((a, b) => b.price - a.price)
                                            .map(e =>
                                                <Row key={generateId()}>
                                                    <Col>
                                                        <b>{e.name}</b>
                                                        <div>{e.details.join('/n')}</div>
                                                    </Col>
                                                    <Col>
                                                        <div>
                                                            {active_user.isLoggedIn ?
                                                                <Button onClick={() => Cart.BuyNow(e)}>Buy: {currency.format(e.price)}</Button> : 
                                                                <CardValues>Price: {currency.format(e.price)}</CardValues>
                                                            }
                                                            <CardValues>Value: {currency.format(e.value)}</CardValues>
                                                         </div>
                                                    </Col>
                                                </Row>
                                            )
                                    }
                                </> : null
                        }

                        {
                            cards.filter(e => e.appProductType === 'GiftCardRecharge').length ?
                                <>
                                    <Title>Existing Gift Cards</Title>
                                    {
                                        cards
                                            .filter(e => e.appProductType === 'GiftCardRecharge')
                                            .sort((a, b) => b.price - a.price)
                                            .map(e =>
                                                <Row key={generateId()}>
                                                    <Col>
                                                        <b>{e.name}</b>
                                                        <div>{e.details.join('/n')}</div>
                                                    </Col>
                                                    <Col>
                                                    <div>
                                                        {active_user.isLoggedIn ?
                                                            <Button onClick={() => Cart.BuyNow(e)}>Buy: {currency.format(e.price)}</Button> : 
                                                            <CardValues>Price: {currency.format(e.price)}</CardValues>
                                                        }
                                                        <CardValues>Value: {currency.format(e.value)}</CardValues>
                                                    </div>
                                                    </Col>
                                                </Row>
                                            )
                                    }
                                </> : null
                        }
                    </div> : <Loading />
            }
        </div>
    )
}

export default Cards;